/* eslint-disable react-hooks/exhaustive-deps */
import {
  DirectionsRenderer,
  GoogleMap,
  Marker,
  Polyline,
  useLoadScript,
} from '@react-google-maps/api'
import {useEffect, useMemo, useState} from 'react'
import {useThemeMode} from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

type Props = {
  WorkSiteLatitude: number | any
  WorkSiteLongitude: number | any
  WorkSiteAddress2?: string | null
}
export const CustomGoogleMap = (props: Props) => {
  const {mode} = useThemeMode()
  const [, setIsOpen] = useState<boolean>(false)
  const {isLoaded} = useLoadScript({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyBbgooU8a529SObF05rdlTa5KAmnPwgQAE',
  })

  const center = useMemo(() => {
    return {lat: props?.WorkSiteLatitude, lng: props.WorkSiteLongitude}
  }, [props.WorkSiteLatitude, props.WorkSiteLongitude])
  return (
    <>
      {!isLoaded ? (
        <h1>Loading...</h1>
      ) : (
        center.lat &&
        center.lng && (
          <GoogleMap
            mapContainerClassName='map-container'
            center={center.lat && center.lng ? center : {lat: 18.52043, lng: 73.856743}}
            zoom={10}
            options={{
              styles:
                mode === 'light'
                  ? null
                  : [
                      {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                      {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                      {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                      {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}],
                      },
                      {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}],
                      },
                      {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{color: '#263c3f'}],
                      },
                      {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#6b9a76'}],
                      },
                      {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{color: '#38414e'}],
                      },
                      {
                        featureType: 'road',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#212a37'}],
                      },
                      {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#9ca5b3'}],
                      },
                      {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{color: '#746855'}],
                      },
                      {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#1f2835'}],
                      },
                      {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#f3d19c'}],
                      },
                      {
                        featureType: 'transit',
                        elementType: 'geometry',
                        stylers: [{color: '#2f3948'}],
                      },
                      {
                        featureType: 'transit.station',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}],
                      },
                      {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{color: '#17263c'}],
                      },
                      {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#515c6d'}],
                      },
                      {
                        featureType: 'water',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#17263c'}],
                      },
                    ],
            }}
            onClick={() => setIsOpen(false)}
          >
            <Marker
              position={center.lat && center.lng ? center : {lat: 18.52043, lng: 73.856743}}
              onClick={() => setIsOpen(true)}
            ></Marker>
          </GoogleMap>
        )
      )}
    </>
  )
}

export const CustomGoogleMapRoute = (props: {marker?: any[]; showPolyLine?: boolean}) => {
  const {mode} = useThemeMode()
  const {isLoaded} = useLoadScript({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyBbgooU8a529SObF05rdlTa5KAmnPwgQAE',
  })

  const onLoad = (map: any) => {
    if (Array.isArray(props.marker)) {
      console.log('aerr', props)

      const bounds = new google.maps.LatLngBounds()
      props.marker?.forEach(({lat, lng}) => bounds.extend({lat, lng}))
      map?.fitBounds(bounds)
    }
  }

  const [directions, setDirections] = useState<any>(null)
  async function calculateRoute() {
    if (Array.isArray(props.marker)) {
      const directionsService = new window.google.maps.DirectionsService()
      console.log(props.marker)
      const waypoints: any[] = props.marker.map((m) => ({
        location: new window.google.maps.LatLng(m.lat, m.lng),
      }))
      console.log(waypoints)

      const origin = waypoints.shift().location
      const destination = waypoints.pop().location

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          waypoints: waypoints,
          travelMode: google.maps.TravelMode.WALKING,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            console.log(result)
            console.log('status', status)

            setDirections(result)
          } else {
            console.error(`error fetching directions ${result}`)
          }
        }
      )
    }
  }

  useEffect(() => {
    if (window?.google && window?.google?.maps) calculateRoute()
  }, [props?.marker, window?.google?.maps, window?.google])

  return (
    <>
      {!isLoaded ? (
        <h1>Loading...</h1>
      ) : (
        <GoogleMap
          mapContainerClassName='map-container'
          onLoad={onLoad}
          options={{
            styles:
              mode === 'light'
                ? null
                : [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}],
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}],
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}],
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}],
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}],
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}],
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}],
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}],
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}],
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}],
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}],
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}],
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}],
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}],
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}],
                    },
                  ],
          }}
        >
          {directions && <DirectionsRenderer directions={directions} />}
          {props?.showPolyLine && (
            <Polyline
              path={props?.marker}
              options={{
                strokeColor: '#89BADB',
                strokeOpacity: 1,
                strokeWeight: 7,
              }}
            />
          )}
        </GoogleMap>
      )}
    </>
  )
}
